import { AuthConfigService, AuthProvider, AuthRoutes } from '@rx-applications/shared/auth/data-access';
import { Route } from '@angular/router';
import { mfaGuard, SignupGuard } from './guards';
import { inject } from '@angular/core';
import { loginErrorGuard } from './guards/login-error.guard';
import { invitationGuard } from './guards/invitation.guard';
import { ssoResolver } from './resolvers/sso-resolver';

export const routes: Route[] = [
  { path: '', redirectTo: AuthRoutes.Login, pathMatch: 'full' },
  {
    path: AuthRoutes.Login,
    canActivate: [loginErrorGuard],
    loadComponent: () => import('@rx-applications/shared/auth/feature-login').then((m) => m.LoginComponent),
    resolve: {
      sso: ssoResolver,
    },
  },
  {
    path: AuthRoutes.Verify,
    canMatch: [mfaGuard()],
    loadComponent: () => import('@rx-applications/shared/auth/feature-verify').then((m) => m.FeatureVerifyComponent),
  },
  {
    path: AuthRoutes.ActivateAccount,
    loadComponent: () =>
      import('@rx-applications/shared/auth/feature-activate-account').then((m) => m.ActivateAccountComponent),
  },
  {
    path: AuthRoutes.Impersonate,
    loadComponent: () => import('@rx-applications/shared/auth/feature-impersonate').then((m) => m.ImpersonateComponent),
  },
  {
    path: AuthRoutes.ImpersonateGuid,
    loadComponent: () => import('@rx-applications/shared/auth/feature-impersonate').then((m) => m.ImpersonateComponent),
  },
  {
    path: AuthRoutes.SetupMFA,
    canMatch: [mfaGuard()],
    loadComponent: () => import('@rx-applications/shared/auth/feature-setup-mfa').then((m) => m.FeatureSetupMfaComponent),
  },
  {
    path: AuthRoutes.Signup,
    loadComponent: () => import('@rx-applications/shared/auth/feature-signup').then((m) => m.SignupComponent),
    canActivate: [SignupGuard],
  },
  {
    path: AuthRoutes.ChangePassword,
    canMatch: [() => inject(AuthConfigService).config?.authProvider === AuthProvider.Cognito],
    loadComponent: () =>
      import('@rx-applications/shared/auth/feature-change-password').then((m) => m.ChangePasswordComponent),
  },
  {
    path: AuthRoutes.ForgotPassword,
    loadComponent: () =>
      import('@rx-applications/shared/auth/feature-forgot-password').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: AuthRoutes.ForceResetPassword,
    loadComponent: () =>
      import('@rx-applications/shared/auth/feature-forgot-password').then((m) => m.ForgotPasswordComponent),
    data: { showHelperText: true },
  },
  {
    path: AuthRoutes.ResetPassword,
    loadComponent: () => import('@rx-applications/shared/auth/feature-reset-password').then((m) => m.ResetPasswordComponent),
  },
  {
    path: AuthRoutes.InvalidUser,
    loadComponent: () => import('@rx-applications/shared/auth/feature-info').then((m) => m.InfoComponent),
  },
  {
    path: AuthRoutes.InvalidInvitation,
    loadComponent: () => import('@rx-applications/shared/auth/feature-info').then((m) => m.InfoComponent),
  },
  {
    path: AuthRoutes.ValidateInvitation,
    canActivate: [invitationGuard],
    loadComponent: () => import('@rx-applications/shared/auth/feature-invitation').then((m) => m.InvitationComponent),
  },
];
